import React from "react";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      {/* 1. Responsive Logic: Resets absolute positioning on small screens */}
      <style>{`
        @media (max-width: 600px) {
          .footer-top-bar {
            position: static !important;
            display: flex !important;
            justify-content: center !important;
            margin: 30px 0 10px 0 !important;
            width: 100% !important;
          }
          .footer-disclaimer {
            padding: 0 10px !important;
            font-size: 10px !important;
          }
        }
      `}</style>

      {/* Top Right Social Icons - Switches to Center on mobile */}
      <div className="footer-top-bar" style={styles.topBar}>
        <div style={styles.icons}>
          <a href="https://www.instagram.com/gauravkabal?utm_source=qr&igsh=MWNuYXI4M2RpNHBraA%3D%3D" target="_blank" rel="noopener noreferrer">
            <img src="instagram.png" alt="insta" style={styles.icon} />
          </a>
          <a href="https://facebook.com/yourprofile" target="_blank" rel="noopener noreferrer">
            <img src="twitter.png" alt="x" style={styles.icon} />
          </a>
        </div>
      </div>

      {/* Bottom Center Content */}
      <div style={styles.bottom}>
        <p className="footer-disclaimer" style={styles.disclaimer}>
          Information provided through informational consulting sessions is for
          informational purposes only and should not be considered legal or
          financial advice. You should consult with an attorney or other
          professional to determine what may be best for your individual needs.
          CryptoConsultz LLC does not make any guarantee or other promise as to
          any results that may be obtained from using this service. No one
          should make any investment decision without first consulting his or
          her own financial advisor and conducting his or her own research and
          due diligence. To the maximum extent permitted by law, CryptoConsultz
          LLC disclaims any and all liability in the event any information,
          commentary, analysis, opinions, advice and/or recommendations prove to
          be inaccurate, incomplete, or unreliable or result in any investment
          or other losses. Customers are required to review Terms of Service,
          Legal Considerations, Risk & Disclaimer carefully prior to use of
          CryptoConsultz LLC services. Your use of the information provided or
          materials is at your own risk.
        </p>

        <img src="logo.jfif" alt="logo" style={styles.logo} />

        <p style={styles.copy}>
          © {new Date().getFullYear()} Your Company. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "#001d62",
    color: "#fff",
    padding: "25px 20px", // Better vertical padding
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Ensures overall centering
    position: "relative",
    overflow: "hidden",
  },

  disclaimer: {
    marginTop: "20px",
    fontSize: "11px",
    color: "#94a3b8", // Slightly brighter gray for better contrast on navy
    lineHeight: "1.6",
    maxWidth: "900px",
    margin: "0 auto 20px auto",
  },

  topBar: {
    position: "absolute",
    top: "30px",
    right: "40px",
  },

  icons: {
    display: "flex",
    gap: "15px",
  },

  icon: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    backgroundColor: "#fff",
    padding: "8px",
    borderRadius: "50%",
    objectFit: "contain",
  },

  bottom: {
    textAlign: "center",
    width: "100%",
  },

  logo: {
    width: "70px",
    height: "auto",
    marginBottom: "15px",
    borderRadius: "8px",
  },

  copy: {
    fontSize: "13px",
    color: "#64748b",
    marginTop: "10px",
  },
};

export default Footer;